/* eslint-disable @next/next/no-img-element */
import Image from "next/image"

import { Aim } from "components/shared/aim"
import { Box } from "components/shared/box"
import { Accordion } from "components/shared/landing/accordion"
import { GradientBox } from "components/shared/landing/gradient-box"
import { Text } from "components/shared/text"

import styles from "./faq.module.scss"

export function Faq() {
  return (
    <Box className={`flex flex-1 min-h-[100vh] w-full items-center pt-[120px] pb-15 px-2 ${styles.faq__bg}`}>
      <Aim>
        <GradientBox className={"max-w-[800px] p-5 md:p-10 rounded-box shadow-md text-white relative z-1"}>
          <Box row className="justify-between w-full">
            <Box className="w-full md:w-auto">
              <Text as="h1" size="h2" className="mb-4 text-center md:text-left">
                FAQ
              </Text>
              <Text as="p" className="mb-8 text-center md:text-left">
                Learn more about our service.
              </Text>
            </Box>
            <Box className="absolute md:relative items-end w-[65px] h-[65px] md:w-[100px] md:h-[100px] right-2">
              <Image
                src="/images/pages/faq/satelite.png"
                alt="decoration"
                width={100}
                height={100}
                className="self-end md:w-auto md:h-auto relative"
              />
            </Box>
          </Box>
          <Accordion header="What is Cryptobots?">
            <Text as="p" size="light" className="opacity-80 mb-3">
              Cryptobots is a pioneer Play-2-Earn NFT game that entered the market in 2017 and gained a loyal audience
              of supporters.
            </Text>

            <Text as="p" size="light" className="opacity-80">
              Cryptobots is currently undergoing a huge update that is being developed by Playneta studio. The alpha
              version of the game will be released in Q1 2022.
            </Text>
          </Accordion>

          <Accordion header="Who are Playneta?">
            <Text as="p" size="light" className="opacity-80">
              Playneta is a game studio from Cyprus. The studio has developed multiple titles that are enjoyed by over
              100M people, leading the way for p2e games to become a metaverse.
            </Text>
          </Accordion>

          <Accordion header="What will the game look like?">
            <Text as="p" size="light" className="opacity-80 mb-3">
              The updated Cryptobots is going to be an epic turn-based strategy set in the futuristic space metaverse.
              Players will be able to battle other players, manage and trade resources, upgrade Bots and spaceships, and
              even merge interplanetary alliances to conquer the deeper space!
            </Text>

            <Text as="p" size="light" className="opacity-80 mb-3">
              Cryptobots game will be available on both desktop and mobile devices.
            </Text>

            <Text as="p" size="light" className="opacity-80">
              To have a glimpse of an upcoming game, check out the Whitepaper and Cryptobots{" "}
              <a className="underline" href="#video">
                gameplay video!
              </a>
            </Text>
          </Accordion>

          <Accordion header="What will make Cryptobots stand out from the other NFT games?">
            <Text as="p" size="light" className="opacity-80">
              We challenge the economic vulnerability of current play&earn games by focusing on building a truly
              sustainable in-game economy based on our disruptive innovations in token utility, staking, burn, and
              earnings that allow a much bigger game economy and in-game market. To find out more on the subject please
              read our{" "}
              <a
                href="https://gitbook.cryptobots.me/cryptobots/"
                className="underline"
                target="_blank"
                rel="noreferrer"
              >
                Whitepaper
              </a>
              .
            </Text>
          </Accordion>

          <Accordion header="When the presale starts? How long will it last?">
            <Text as="p" size="light" className="opacity-80">
              The NFT presale whitelist will last from Jan 2 to Feb 3, 2022, ending with whitelisted presale and public
              round.
            </Text>
          </Accordion>

          <Accordion header="What are you pre-selling and why?">
            <Text as="p" size="light" className="opacity-80 mb-3">
              The Genesis Cryptobots NFTs are playable characters that will form the foundation of the Cryptobots
              gameplay and are needed to start playing and producing more Cryptobots for the new players.
            </Text>

            <Text as="p" size="light" className="opacity-80">
              This presale is necessary to ensure that there will be enough Bots at the game launch for the majority of
              players to form the teams of 3-4 Cryptobots required for the core gameplay mechanics.
            </Text>
          </Accordion>

          <Accordion header="What is the difference between Classic 2017 Cryptobots and the Genesis Cryptobots?">
            <Text as="p" size="light" className="opacity-80 mb-3">
              The 2017 Cryptobots Classic collection is a piece of NFT archeology by itself, with many people holding
              the Bots for years just to own that piece of early blockchain history. Therefore, it was decided to limit
              the Classic 2017 collection to 10,000 Bots, renounce the contract ownership, and not integrate them into
              the game <span className="text-primary">as playable characters</span>. This will make sure the Classic
              Collection is not inflated and the historic value of every Bot is preserved.
            </Text>

            <Text as="p" size="light" className="opacity-80 mb-3">
              Please keep in mind that all holders of the 2017 Classic collection will be able to exchange their classic
              Bots for the playable ones and will also receive additional bonuses.
            </Text>

            <Text as="p" size="light" className="opacity-80">
              The new collection is called Cryptobots Genesis! These Bots will be fully playable in the Cryptobots game
              and will become an integral part of every gameplay mechanic.
            </Text>
          </Accordion>

          <Accordion header="What is the whitelist price?">
            <Text as="p" size="light" className="opacity-80">
              The presale price is 0.1 ETH per one Cryptobot.
            </Text>
          </Accordion>

          <Accordion header="How many new Cryptobots will be available on the pre-sale?">
            <Text as="p" size="light" className="opacity-80">
              There will be 10000 Bots available for the presale.
            </Text>
          </Accordion>

          <Accordion header="Which platform will you use for minting?">
            <Text as="p" size="light" className="opacity-80">
              Cryptobots Website.
            </Text>
          </Accordion>

          <Accordion header="Will there be a public sale stage?" className="mb-0">
            <Text as="p" size="light" className="opacity-80">
              Yes, the unsold presale Bots will be later available on the public sale stage.
            </Text>
          </Accordion>
        </GradientBox>
      </Aim>
    </Box>
  )
}
